$(document).ready(function(){
        $('.upsell-slider-wrapper').hide();

    let sliderInitialized = false;


    // Function to check and add form if missing
function addFormIfMissing() {
  // Select all modal elements with class 'yehihy'
  const modals = document.querySelectorAll('.modal--root.yehihy');

  // Loop through each modal element
  modals.forEach(modal => {
    // Get the form ID from the modal's data-form-id attribute
    const formId = modal.getAttribute('data-form-id');

    if (formId) {
      // Check if the form with the specific ID already exists inside this modal
      const existingForm = modal.querySelector(`#${formId}`);

      // If the form is missing
      if (!existingForm) {
        // Create the form element with the unique ID
        const newForm = document.createElement('form');
        newForm.setAttribute('method', 'post');
        newForm.setAttribute('action', '/cart/add');
        newForm.setAttribute('id', formId);  // Use the dynamic form ID
        newForm.setAttribute('accept-charset', 'UTF-8');
        newForm.setAttribute('class', 'product-form--container');
        newForm.setAttribute('enctype', 'multipart/form-data');

        // Copy all child elements of the modal into the form
        while (modal.firstChild) {
          // Move the child elements into the new form
          newForm.appendChild(modal.firstChild);
        }

        // Append the newly created form into the modal
        modal.appendChild(newForm);
      }
    }
  });
}



    
    function initializeSlider() {
        // var $upsellItems = $('.upsell-item').not('.hidden');
        // var visibleCount = $upsellItems.length;
        
        // console.log('Initializing slider with', visibleCount, 'visible items');
        
        // if (visibleCount === 0) {
        //     console.log('No visible items - hiding section');
        //     $('.upsell-slider-wrapper').hide();
        //     if (sliderInitialized) {
        //         $('.upsell-slider').slick('unslick');
        //         sliderInitialized = false;
        //     }
        //     return;
        // }
        
        
        /*
        if (sliderInitialized) {
            console.log('Reinitializing slider');
            $('.upsell-slider').slick('unslick');
        }*/
        
        // $('.upsell-slider').slick({
        //     slidesToShow: Math.min(3, visibleCount),
        //     slidesToScroll: 1,
        //     autoplay: false,
        //     autoplaySpeed: 1500,
        //     arrows: true,
        //     dots: false,
        //     infinite: true,
        //     adaptiveHeight: true,
        //     prevArrow: $('.upsell-previous'),
        //     nextArrow: $('.upsell-next'),
        //     responsive: [
        //         {
        //             breakpoint: 768,
        //             settings: {
        //                 slidesToShow: Math.min(2, visibleCount),
        //                 arrows: true
        //             }
        //         },
        //         {
        //             breakpoint: 480,
        //             settings: {
        //                 slidesToShow: 2,
        //                 arrows: true
        //             }
        //         }
        //     ]
        // });

        

        $('.upsell-slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            adaptiveHeight: false,
            gap:15,
            centerMode: false,
            infinite:true,
            prevArrow: $('.upsell-previous'),
            nextArrow: $('.upsell-next'),
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        arrows: true
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        arrows: true
                    }
                }
            ]
        });
        
        sliderInitialized = true;
        console.log('Slider initialized successfully');
        // Call the function to check and add forms where missing
addFormIfMissing();
        setTimeout(()=>{
        $('.upsell-slider-wrapper').show()

        },4000)
    }

    // Initial setup - initialize slider first, then check cart status
    console.log('Initial setup started');
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        console.log('Number of items in the cart:', cart.items.length);
        if(cart.items.length > 0){
        initializeSlider();
        }
    })
    .catch(error => console.error('Error fetching cart:', error));
    
      

    $(document).on('click', '.defaultaddbtn', function() {
        console.log('Button clicked!');
        console.log('Slider lost — reinitializing');
        initializeSlider();
    });

    // Monitor the slider every 2 seconds
    setInterval(() => {
        console.log("running")
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                const $slider = $('.upsell-slider');

                if ($slider.length && !$slider.hasClass('slick-initialized')) {
                    console.log('Slider added or changed — initializing...');
                    initializeSlider();
                }
            });
        });

        // Start observing the document body or a more specific container
        observer.observe(document.body, {
            childList: true,       // watch for added/removed elements
            subtree: true          // watch deeply in the DOM
        });

    }, 2000);
   
    // Handle window resize
    // $(window).on('resize', function() {
    //     if (sliderInitialized) {
    //         $('.upsell-slider').slick('resize');
    //     }
    // }); 
});





const refreshCart = ()=>{
    console.log("calling function")
    return theme.partials.OffCanvas.load();
}